import { ProfileStore } from '../stores/profile';
import { BytesPerKb, ISelect } from '../interfaces';
import {
    byteSignificantDigits,
    formatBytesIntegerOnly,
    minutesRange,
    range,
    range1000,
    smsRange,
} from '../instruments';
import { rateLabels } from '../instruments/rate';

const getProfileBytesPerKb = (): BytesPerKb => {
    const ProfileInstance = ProfileStore.getInstance();
    const { bytesPerKb } = ProfileInstance.profileSettings;
    return bytesPerKb || BytesPerKb.HUMAN;
};

const getProfileBytesPerKbDivider = (): number => {
    return Number(getProfileBytesPerKb());
};

export const profileBytesSignificantDigits = (bytes: any, decimals = 0): string => {
    return byteSignificantDigits(bytes, getProfileBytesPerKbDivider(), decimals);
};

export const profileFormatBytes = (byte: number | null | undefined): string => {
    return formatBytesIntegerOnly(byte, getProfileBytesPerKbDivider());
};

export function profileHumanFormatBytes(bytes?: number | null | undefined): string {
    const base = getProfileBytesPerKbDivider();
    const units = rateLabels.bytes;

    if (!bytes) return `0 ${units[0]}`;

    const i = Math.min(Math.floor(Math.log(bytes) / Math.log(base)), units.length - 1);
    const unit = units[i] ?? units[0];

    let num = bytes / Math.pow(base, i);

    if (num >= 100) {
        num = Math.round(num);
    } else {
        num = Math.round(num * 10) / 10;
    }

    return `${num} ${unit}`;
}

export const showOriginalUnitByType = (value = '0', unitType?: ISelect, byteDecimal = 0): string => {
    switch (unitType?.id) {
        case '1':
            return range(value, getProfileBytesPerKbDivider(), byteDecimal, rateLabels.bytes);
        case '2':
            return smsRange(value);
        case '3':
            // return timeRange(value);
            return minutesRange(value);
        default:
            // return stringCount(value);
            return range1000(value);
    }
};

type ITick = number | { v: number; f: string };
export const calcChartTicks = (minValue = 0, maxValue = 100, partCount = 5, unitType?: ISelect): Array<ITick> => {
    const ticks: Array<ITick> = [];
    const lenMinValue = minValue.toFixed().length;
    const realMinValue = minValue === 0 ? 0 : Math.floor(minValue / 10 ** (lenMinValue - 1)) * 10 ** (lenMinValue - 1);
    const range = maxValue - realMinValue;
    const step = range / partCount;
    const lenStep = step.toFixed().length;
    const realStep = Math.round(step / 10 ** (lenStep - 1)) * 10 ** (lenStep - 1);

    let currentPosition = realMinValue;
    do {
        ticks.push({ v: currentPosition, f: showOriginalUnitByType(currentPosition.toFixed(), unitType) });
        currentPosition = currentPosition + realStep;
    } while (currentPosition < maxValue);

    return ticks;
};
